import { useEffect, useState } from 'react'

import { useFetch } from '@marketplace-web/core-api/api-client-util'
import {
  getBumpAgainSuggestion,
  useGetBumpAgainSuggestionApiGateway,
  transformBumpAgainSuggestionResponse,
} from '@marketplace-web/vas/vas-data'
import {
  usePromoAfterItemUploadContext,
  PromoAfterItemUpload,
} from '@marketplace-web/item-upload/after-upload-actions-feature'

import { useFeatureSwitch } from '@marketplace-web/feature-flags/feature-switches-data'

import {
  getIsBumpAgainSuggestionSeen,
  setBumpAgainSuggestionAsSeen,
} from '../../../utils/bumpAgainSuggestionCap'

const useFetchBumpAgainSuggestion = () => {
  const isBumpAgainSuggestionSeen = getIsBumpAgainSuggestionSeen()
  const getBumpAgainSuggestionApiGateway = useGetBumpAgainSuggestionApiGateway()

  const isApiGatewayClientEnabled = useFeatureSwitch('web_api_gateway_client')
  const isApiGatewayClientEnabledForVas = useFeatureSwitch('web_api_gateway_client_vas')
  const isApiGatewayEnabled = isApiGatewayClientEnabled && isApiGatewayClientEnabledForVas

  const getBumpAgainSuggestionRequest = isApiGatewayEnabled
    ? getBumpAgainSuggestionApiGateway
    : getBumpAgainSuggestion

  const { fetch: fetchBumpAgainSuggestion, transformedData: bumpAgainSuggestionData } = useFetch(
    getBumpAgainSuggestionRequest,
    transformBumpAgainSuggestionResponse,
  )

  const { currentPromotion } = usePromoAfterItemUploadContext()

  const [isPromoAfterItemUploadShown, setIsPromoAfterItemUploadShown] = useState(false)

  useEffect(
    function checkPromoAfterItemUpload() {
      if (!currentPromotion) return
      if (currentPromotion === PromoAfterItemUpload.Empty) return

      setIsPromoAfterItemUploadShown(true)
    },
    [currentPromotion],
  )

  useEffect(
    function fetchData() {
      if (isBumpAgainSuggestionSeen) return
      if (isPromoAfterItemUploadShown) return
      if (currentPromotion !== PromoAfterItemUpload.Empty) return

      fetchBumpAgainSuggestion()
    },
    [
      isBumpAgainSuggestionSeen,
      currentPromotion,
      isPromoAfterItemUploadShown,
      fetchBumpAgainSuggestion,
    ],
  )

  useEffect(
    function registerBumpAgainSuggestionAsSeen() {
      if (!bumpAgainSuggestionData?.bumpAgainSuggestion) return

      setBumpAgainSuggestionAsSeen()
    },
    [bumpAgainSuggestionData],
  )

  return {
    showBumpAgainSuggestion: !!bumpAgainSuggestionData?.bumpAgainSuggestion,
    soldItemId: bumpAgainSuggestionData?.bumpAgainSuggestion?.soldItemId,
  }
}

export default useFetchBumpAgainSuggestion
